import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { AchievementsSection } from '../components/sections/AchievementsSection';
import { OfferStackSection } from '../components/sections/OfferStackSection';
import { IdentitySection } from '../components/sections/IdentitySection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../QA Section';
import { FinalCtaSection } from '../components/sections/FinalCtaSection';
import { FooterSection } from '../FOOTER LEGAL';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#0a1628] overflow-x-hidden" data-id="element-323">
      <HeroSection data-id="element-324" />
      <ProblemSection data-id="element-325" />
      <AchievementsSection data-id="element-326" />
      <OfferStackSection data-id="element-327" />
      <IdentitySection data-id="element-328" />
      <TestimonialsSection data-id="element-329" />
      <GuaranteeSection data-id="element-330" />
      <FAQSection data-id="element-331" />
      <FinalCtaSection data-id="element-332" />
      <FooterSection data-id="element-333" />
    </main>;
}